import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { UserDomainModel } from '../../domainModels/user-domain-model';
import { NavigationService } from '../navigation.service';

type Activation = Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree;

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  constructor(
    public userDomainModel: UserDomainModel,
    public router: Router,
    private navigationService: NavigationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Activation {
    return this.userDomainModel.userSession$.pipe(
      map(session => session !== null && session?.hasAccessToken()),
      tap(hasSession => {
        if (!hasSession) {
          this.navigationService.signIn();
        }
      })
    );
  }
}
